import { useReducer } from "react";
import { modalAction, modalInitialState, modalReducer } from "./reducers";
import { studentPmrColumns } from "./constants";
import { useMutation, useQuery } from "react-query";
import { CustomAlert } from "components";
import { NakedTable } from "components";
import { Button } from "reactstrap";
import apiService from "services/api";
import { AddNewParentMeetingModal } from "./components/AddNewParentMeeting";
import { useNotificationContext } from "contexts";

const ParentMeeting = ({ student }) => {
  const { data: studentPmrs, refetch } = useQuery(
    ["studentPmrs", student?.id],
    () => apiService.studentPmr.get(student?.id),
    { enabled: !!student?.id },
  );

  const [addParentMeetingModalState, addParentMeetingModalDispatch] =
    useReducer(modalReducer, modalInitialState);

  const [deleteParentMeetingModalState, deleteParentMeetingModalDispatch] =
    useReducer(modalReducer, modalInitialState);

  const { createNotification } = useNotificationContext();

  const { mutate: deleteParentMeeting, isLoading: isDeletingParentMeeting } =
    useMutation({
      mutationFn: () =>
        apiService.studentPmr.delete(
          deleteParentMeetingModalState.data?.studentId,
          deleteParentMeetingModalState.data?.id,
        ),
      onSuccess: () => {
        refetch();
        deleteParentMeetingModalDispatch({ type: modalAction.CLOSE });
      },
      onError: () =>
        createNotification({
          type: "danger",
          message: "Failed to delete parent meeting record",
        }),
    });

  return (
    <>
      <CustomAlert
        show={deleteParentMeetingModalState.show}
        hideModal={() =>
          deleteParentMeetingModalDispatch({ type: modalAction.CLOSE })
        }
        title="Confirm Delete Parent Meeting Record?"
        submitButtonText="Proceed"
        disabled={isDeletingParentMeeting}
        submitModal={deleteParentMeeting}
        width="500px"
        body={
          <div>Are you sure you want to delete this parent meeting record?</div>
        }
        fitToParent={false}
      />
      <AddNewParentMeetingModal
        show={addParentMeetingModalState.show}
        studentId={student?.id}
        hideModal={() =>
          addParentMeetingModalDispatch({ type: modalAction.CLOSE })
        }
        refetch={refetch}
      />

      <Button
        size="sm"
        color="info"
        type="button"
        className="mb-3"
        onClick={() =>
          addParentMeetingModalDispatch({
            type: modalAction.OPEN,
            payload: student?.id,
          })
        }
      >
        Add Parent Meeting
      </Button>

      <NakedTable
        data={studentPmrs || []}
        columns={studentPmrColumns((row) =>
          deleteParentMeetingModalDispatch({
            type: modalAction.OPEN,
            payload: row,
          }),
        )}
        title="Parent Meetings"
      />
    </>
  );
};

export default ParentMeeting;
